import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  TableContainer,
} from "@mui/material";
import { FC,MouseEvent } from "react";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import TableComponent from "../component/TableComponent";
import { useForm } from "react-hook-form";
import { agingReportPdf, agingReportTable } from "./services";
import useRepotFile from "../hooks/reportFileHook";
import { useMutation } from "react-query";

const AgingReport: FC = () => {
  const { handleSubmit,control,getValues,reset } = useForm();

  const {mutate:getAgingReportPdf,isLoading:pdfLoading} = useRepotFile({apiFunction:agingReportPdf})
  const {mutate:getAgingReportTable,data:agingReportData,isLoading:agingReportTableDataLoading,reset:resetMutation} = useMutation(agingReportTable)
  const onSubmit = (data: any) => {
    getAgingReportTable(data);
  };
  const clearForm = ()=>{
    reset({
        fromDate:'',
        toDate:''
    })
    resetMutation()
  }

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
      const fileType = e.currentTarget.dataset.filetype;
      const allData = getValues();
      if (fileType === "pdf") {
        getAgingReportPdf({
          fromDate: allData.fromDate,
          toDate: allData.toDate,
        });
      }
    };

  const onChange = ()=>{
     const data = getValues()
     if(data.fromDate && data?.toDate){
        getAgingReportTable(data as {fromDate:string,toDate:string})
     }else{
      resetMutation()
    }
  }

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Aging Report
          </Typography>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "TO Date is required",onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button
              type="submit"
            //   disabled={reportLoading}
            //   endIcon={reportLoading && <CircularProgress size={18} />}
            >
              search
            </Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={pdfLoading || !Boolean(agingReportData?.response?.length)}
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          {/* <Button
            // disabled={excelLoading || !Boolean(revenueData?.response?.length)}
            // endIcon={excelLoading && <CircularProgress size={18} />}
            data-filetype="excel"
            onClick={getFiles}
          >
            excel
          </Button> */}
        </div>
        <TableComponent
          loading={agingReportTableDataLoading}
          data={agingReportData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default AgingReport;

const heading = [
    {
        heading: "Claim Id",
        key: "claim_id",
    },
    {
        heading: "Claim Submit Id",
        key: "claimSubmitId",
    },
    {
        heading: "PHN No",
        key: "phnNo",
    },
    {
        heading: "Name",
        key: "Name",
    },
    {
        heading: "Insurance Type",
        key: "InsType",
    },
    {
        heading: "Insurance Name",
        key: "InsuranceName",
    },
    {
        heading: "Insurance Share",
        key: "InsuranceShare",
    },
    {
        heading: "Days",
        key: "days",
    },
    {
        heading: "Claim Submitted Date",
        key: "claimSubmittedDate",
        date:"DD-MM-YYYY hh:mm A",
        format:"DD/MM/YYYY HH:mm A" // 2025-05-06T02:09:14.000+00:00
    },
]

